var map = {
	"./designer.en.json": "6406",
	"./designer.es.json": "6bfc",
	"./information.en.json": "fce1",
	"./information.es.json": "6821",
	"./public.en.json": "f342",
	"./public.es.json": "b367",
	"./sc.en.json": "a51c",
	"./sc.es.json": "d880"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b93c";